(function () {
  var SECTION_SELECTOR = '.oddit-section-key-traits';
  var sectionState = new Map();

  function initMarquee(section) {
    var track = section.querySelector('[data-marquee-track]');
    var firstSet = section.querySelector('[data-marquee-set]');
    if (!track || !firstSet) return null;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var sectionKey = section.dataset.sectionId || Math.random().toString(36).slice(2);

    function measure() {
      var setWidth = firstSet.scrollWidth;
      var trackStyle = getComputedStyle(track);
      var trackGap = parseFloat(trackStyle.columnGap) || parseFloat(trackStyle.gap) || 0;
      var distance = setWidth + trackGap;
      track.style.setProperty('--marquee-distance', '-' + distance + 'px');
    }

    function enable() {
      measure();
      track.style.animationPlayState = 'running';
    }

    function disable() {
      track.style.animationPlayState = 'paused';
    }

    if (reducedMotion.matches) {
      disable();
    } else {
      enable();
    }

    var ro = new ResizeObserver(function () {
      if (!reducedMotion.matches) measure();
    });
    ro.observe(section);

    function handleMotionChange(e) {
      e.matches ? disable() : enable();
    }

    function handleVisibility() {
      if (reducedMotion.matches) return;
      track.style.animationPlayState = document.hidden ? 'paused' : 'running';
    }

    reducedMotion.addEventListener('change', handleMotionChange);
    document.addEventListener('visibilitychange', handleVisibility);

    return {
      ro: ro,
      cleanup: function () {
        reducedMotion.removeEventListener('change', handleMotionChange);
        document.removeEventListener('visibilitychange', handleVisibility);
      },
      key: sectionKey,
    };
  }

  function destroyMarquee(state) {
    if (!state) return;
    if (state.ro) state.ro.disconnect();
    if (state.cleanup) state.cleanup();
  }

  function initSection(section) {
    if (!section) return;
    var state = { marquee: initMarquee(section) };
    var key = section.id || section.dataset.sectionId || 'oddit-key-traits-' + sectionState.size;
    sectionState.set(key, state);
  }

  function destroySection(section) {
    if (!section) return;
    var key = section.id || section.dataset.sectionId;
    var state = sectionState.get(key);
    if (!state) return;
    destroyMarquee(state.marquee);
    sectionState.delete(key);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();